import { FC, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { useCurrentGroup } from '@/hooks/use-current-group';
import { useGroupsUrl } from '@/hooks/use-groups-url';
import { OrganisationOverrideProvider } from '@/hooks/use-organisation-override-context';

export const GroupRouteWrapper: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const {
    data: group,
    isFetching: isFetchingGroup,
    isUninitialized: isGroupUninitialized,
  } = useCurrentGroup();
  const isLoadingGroup = isGroupUninitialized || isFetchingGroup;
  const groupsUrl = useGroupsUrl();

  const groupId = group?.id ?? -1;

  useEffect(() => {
    if (!isLoadingGroup && groupId < 0) {
      navigate(groupsUrl);
    }
  }, [isLoadingGroup, groupsUrl, groupId, navigate]);

  if (groupId < 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <BeatLoader />
      </div>
    );
  }

  return (
    <OrganisationOverrideProvider
      organisation={{
        id: group!.organisation.id,
        name: group!.organisation.name,
      }}
    >
      {children}
    </OrganisationOverrideProvider>
  );
};
